var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel-header',{class:_vm.b()},[_c('div',{class:_vm.b('content')},[_c('span',{class:_vm.b('title')},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.badges),function(badge,i){return (badge.count > 0)?_c('span',{key:i,class:[_vm.b('badge'), badge.color]},[_vm._v(_vm._s(badge.count))]):_vm._e()})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }